import { black } from '@pelotoncycle/design-system';
import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import styled from 'styled-components';
import type { PropsOf } from '@peloton/react';
import type { BaseModalProps } from './BaseModal';
import BaseModal from './BaseModal';
import ModalGlobalStyles from './ModalGlobalStyles';
import { modalOpened, modalClosed } from './redux';
import CloseButton from './shared/CloseButton';

export type TileModalProps = BaseModalProps & {
  darkMode?: boolean;
};

type DispatchProps = {
  modalOpened: () => void;
  modalClosed: () => void;
};

const mapDispatchToProps = {
  modalOpened,
  modalClosed,
};

class ViewportModal extends BaseModal<TileModalProps & DispatchProps> {
  public render() {
    const { isOpen = true, contentLabel, closeHandler, darkMode, ...props } = this.props;

    return (
      <StyledModal
        isOpen={isOpen}
        role="dialog"
        aria-modal="true"
        aria-label={contentLabel}
        className="tile-modal"
        closeTimeoutMS={400}
        onAfterOpen={this.handleAfterOpen}
        onRequestClose={this.handleRequestClose}
      >
        <ModalGlobalStyles darkMode={darkMode} />
        <CloseButton
          contentLabel={contentLabel}
          onClick={this.handleRequestClose}
          darkMode={darkMode}
          {...props}
        />
        {this.props.children}
      </StyledModal>
    );
  }

  handleAfterOpen = () => {
    // Apply the saved scroll position to the #root element when the modal is opened
    const rootElement = document.getElementById('root')!;
    rootElement.scrollTop = this.savedScrollPosition;
    this.props.modalOpened();
  };

  handleRequestClose = () => {
    this.applySavedScrollPosition();
    this.props.closeHandler && this.props.closeHandler();
    this.props.modalClosed();
  };
}

export default connect(undefined, mapDispatchToProps)(ViewportModal);

const StyledModal: React.FunctionComponent<
  React.PropsWithChildren<PropsOf<typeof ReactModal>>
> = styled(ReactModal)`
  align-items: center;
  display: flex;
  justify-content: center;
  outline: none;
  width: 100%;
  height: 100%;
  background: ${black};
`;
